import React from "react"
import DtrfMobile from "../../component/DtrfFromMobile/DtrfMobile"

const DtrfMobileForm = () => <DtrfMobile />

export default DtrfMobileForm